import React from 'react';
import PropTypes from 'prop-types';

import { useLocationStep } from 'components/Booking-new/utils/steps/location';

import { ChangeLocationLink } from './styles';

const ChangeLocationButton = ({ isLocationStep }) => {
  const { changeLocation, goToLocationStep, changeLocationLabel } = useLocationStep();

  const handleOnClick = () => {
    !isLocationStep && goToLocationStep();
    changeLocation();
  };

  return (
    <>
      <ChangeLocationLink variant="DS_copyMediumRegular" component="button" onClick={handleOnClick}>
        {changeLocationLabel}
      </ChangeLocationLink>
    </>
  );
};

ChangeLocationButton.defaultProps = {
  isLocationStep: false,
};

ChangeLocationButton.propTypes = {
  isCenter: PropTypes.bool,
  isLocationStep: PropTypes.bool,
};

export default ChangeLocationButton;
